__turbopack_context__.v({
  "details": "personal-details-module-sass-module__aqQgZq__details",
  "verifyMessage": "personal-details-module-sass-module__aqQgZq__verifyMessage",
});
